import { useState } from "react";
import Constantes from "../../constantes";
function Recuperar() {

    const [email, setEmail] = useState('');
    const [passw, setPassw] = useState('');

    const procesarPeticion = async (e) => {
        e.preventDefault()
        try {

            const respuesta = await fetch(Constantes.RUTA_API + '/usuarios/recuperar', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ email, passw }),
            })
            const data = await respuesta.json();
            alert(data.message);

        } catch (error) {
            console.error('Error al enviar:', error);
            alert('Hubo un error al enviar el formulario');
        }
    }

    return (
        <>
            <div className="App d-flex justify-content-center bg-dark text-white">

                <form onSubmit={procesarPeticion}>

                    <div class="mb-4 mt-4">
                        <label for="email" class="form-label">Email:</label>
                        <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" class="form-control" id="email" placeholder="yourny.oficial@gmail.com 📧" name="email" />
                    </div>
                    <div class="mb-4 mt-4">
                        <label for="passw" class="form-label">Nueva contraseña:</label>
                        <input value={passw} onChange={(e) => setPassw(e.target.value)} type="password" class="form-control" id="passw" placeholder="Nueva contraseña 🔐" name="passw" />
                    </div>
                    <button type="submit" class="my-4 btn btn-primary" style={{ width: "100%" }}>Solicitar cambio de contraseña</button>

                    <p>*Nota informativa, si no tienes acceso al correo de la cuenta no podrás recuperar la cuenta ☺☻</p>
                </form>
            </div>

            <title>Recuperación de cuenta</title>
        </>
    );
}



export default Recuperar;